export default "__VITE_ASSET__DnFT3kCR__"